import EmblaCarousel from 'embla-carousel';
import ClassNames from 'embla-carousel-class-names';
window.EmblaCarousel = EmblaCarousel;

import Alpine from 'alpinejs';
import intersectClass from 'alpinejs-intersect-class'
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus'
import ajax from '@imacrayon/alpine-ajax';
window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.plugin(intersectClass);
Alpine.plugin(collapse);
Alpine.plugin(ajax);
Alpine.start();

// Social share links
import Socials from './modules/_social_share_links.js';

function init() {
  Socials.setup();
}

init();